/**
 * Recursive function which determines the level of nesting for any segmentation value in an insight pages structure/template
 * Will search for parents on the segmentation value object, and recursively run up the tree keeping a counter per level
 * Stops as soon as there are no parents found or when an other-row was found
 * @param  {Object} segmentationValue The segmentation value object to perform the lookup on
 * @param  {Number} counter           A counter to keep track of the levels
 * @return {Number}                   Returns a number representing the amount of levels the value object was nested deep
 */
export default function checkSegmentationValueLevel(
  segmentationValue,
  counter,
) {
  if (segmentationValue.parent && segmentationValue.parent.id !== 'other') {
    return checkSegmentationValueLevel(segmentationValue.parent, counter + 1);
  }

  if (segmentationValue.parent && segmentationValue.parent.id === 'other') {
    return counter + 1;
  }

  return counter;
}
